var map = {
	"./p-minus-0.svg": 1450,
	"./p-minus-1.svg": 1451,
	"./p-minus-2.svg": 1452,
	"./p-minus-3.svg": 1453,
	"./p-minus-4.svg": 1454,
	"./p-plus-0.svg": 1455,
	"./p-plus-1.svg": 1456,
	"./p-plus-2.svg": 1457,
	"./p-plus-3.svg": 1458,
	"./p-plus-4.svg": 1459
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1449;